// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import('./app/components/applicationBootstrap/ApplicationBootstrap');
